<template class='HomePageNav'>
  <div>
    <div class="pc header" v-if="!pageY">
      <!-- <div class="top-nav">
            <span><a to="/appDownLoad" class="appXiaZai">APP下载</router-link ></span>
            <span class="appXiaZai">
              <a href="http://www.4006688991.com/player?studentLogin&EngineAddress=http://www.4006688991.com" class="appXiaZai" target="_blank">开始学习</a>
              </span>
      </div> -->
      <ul class="theonemenu">
        <li style="margin-right:0;" @click="routerToFirst" class="imgMouseEnter">
          <img src="../assets/image/homePage/index/PCImage/header_logo_pc.png" style=" " alt="logo">
        </li>
        <li class="firstmenu" style="margin-left:2.708vw;margin-right:3.229vw;">
          <a href="https://www.imaginelearning.cn" target="_blank">首页</a>
        </li>
        <li class="firstmenu">
          <a href="https://www.imaginelearning.cn/Curricula" target="_blank">课程体系</a>
          <ul class="twomenu">
            <li class="ts lBorder third-menu-hover-pc">
              <a href="https://www.imaginelearning.cn/CurriculumRationale" target="_blank">课程理念</a>
              <!-- <div class="dynamicTime " style="left:-.3vw;"></div> -->
            </li>
            <li class="ts rBorder">
              <a href="https://www.imaginelearning.cn/O2OCourses" target="_blank">线上线下课程体系</a>
            </li>
            <!-- <li class="ts rBorder"><a href="#">线下精准教学</a></li> -->
          </ul>
        </li>
        <!-- <li class="firstmenu"><router-link to="/aboutImagine"   >关于想象力</router-link > -->
        <li class="firstmenu">
          <a href="https://www.imaginelearning.cn/AboutUs" target="_blank">关于想象力</a>
          <ul class="twomenu lastmenu">
            <li class="ts rBorder">
              <a href="https://www.imaginelearning.cn/ContactUs" target="_blank">联系我们</a>
            </li>
            <li class="ts border-r-pc">
              <a href="https://www.imaginelearning.cn/JoinUs" target="_blank">加入我们</a>
            </li>
            <li class="ts lBorder third-menu-hover-pc">
              <a href="https://www.imaginelearning.cn/AboutTheFounder" target="_blank">创始人介绍</a>
            </li>
          </ul>
        </li>
          <li class="firstmenu">
          <!-- <a href="http://4006688991.cn/app" target="_blank">App下载</a> -->
              <router-link to="/appDownLoad">App下载</router-link>
        </li>
        <li class="phone-number">
          <img src="../assets/image/homePage/index/PCImage/phone_icon.png" alt="">
          <p>咨询热线：400 6688 991</p>
        </li>
      </ul>
    </div>
   <div class="phone" v-if="!testShow">
      <div class="phoneNavBox">
        <div class="menuBox">
          <div class="navTop">
            <!-- <div class="navLogo">
                      <router-link to="/" style="widht:100%;height:100%;"></router-link>
            </div>-->

            <div style>
              <router-link to="/" class="navLogo"></router-link>
            </div>
            <!-- 手机-->
            <!-- 下载 end -->
            <div class="menuRightBox" @click="xuanzhuanIcon(0)">
              <div class="menuClickBox" :class="{menuCloseBox:fMenu[0].flag}"></div>
            </div>
          </div>
        </div>
        <div class="xialaMenu boxBG" @scroll.native.stop :class="{fade:fMenu[0].flag}">
          <!-- :style="{'height': fMenu[0].flag?navTransitionHeight.allFirstMenuBoxHeight:0}" -->
          <div>
            <div class="firstMenuBox">
              <div class="lyrouter lyrouter1" :class="{fade:fMenu[0].flag}">
                <a href="https://www.imaginelearning.cn/" class="routerBtn" :class="{fontBold:firstRouterColor[0]}">首页</a>
              </div>
              <!-- <div class="ArrowBox">
                          <div class="arrow"></div>
              </div>-->
            </div>
          </div>
          <div>
            <div class="firstMenuBox" :class="{menuSecondBg:fMenu[2].flag}">
              <div class="lyrouter lyrouter3" :class="{fade:fMenu[0].flag}">
                <a
                  href="https://www.imaginelearning.cn/Curricula"
                  class="routerBtn"
                  :class="{fontBold:firstRouterColor[2]}"
                >课程体系</a>
              </div>
              <div class="ArrowBox" @click="xuanzhuanIcon(2)">
                <div class="arrow" :class="{upArrow:fMenu[2].flag}"></div>
              </div>
            </div>
            <div v-if="fMenu[2].flag===true&&fMenu[2].index===2">
              <div class="secondMenuBox">
                <a href="https://www.imaginelearning.cn/CurriculumRationale" class="routerSecBtn">课程理念</a>
              </div>
              <div class="secondMenuBox">
                <a href="https://www.imaginelearning.cn/O2OCourses" class="routerSecBtn">线上线下课程体系</a>
              </div>
            </div>
          </div>
          <div>
            <div class="firstMenuBox" :class="{menuSecondBg:fMenu[6].flag}">
              <div class="lyrouter lyrouter7" :class="{fade:fMenu[0].flag}">
                <a
                  href="https://www.imaginelearning.cn/AboutUs"
                  class="routerBtn"
                  :class="{fontBold:firstRouterColor[6]}"
                >关于想象力</a>
              </div>
              <div class="ArrowBox" @click="xuanzhuanIcon(6)">
                <div class="arrow" :class="{upArrow:fMenu[6].flag}"></div>
              </div>
            </div>

            <div v-if="fMenu[6].flag===true&&fMenu[6].index===6">
              <div class="secondMenuBox">
                <a href="https://www.imaginelearning.cn/AboutTheFounder" class="routerSecBtn">创始人介绍</a>
              </div>
              <div class="secondMenuBox">
                <a href="https://www.imaginelearning.cn/JoinUs" class="routerSecBtn">加入我们</a>
              </div>
              <div class="secondMenuBox">
                <a href="https://www.imaginelearning.cn/ContactUs" class="routerSecBtn">联系我们</a>
              </div>
            </div>
          </div>
            <div>
            <div class="firstMenuBox" :class="{menuSecondBg:fMenu[5].flag}">
              <div class="lyrouter lyrouter6" :class="{fade:fMenu[0].flag}">
                <a
                  href="http://app.4006688991.cn"
                  class="routerBtn"
                  target="_blank"
                >App下载</a>
              </div>
              <!-- <div class="ArrowBox" @click="xuanzhuanIcon(5)">
                          <div class="arrow" :class="{upArrow:fMenu[5].flag}"></div>
              </div>-->
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Bus from "../config/bus";
export default {
  name: "homePage",
  data() {
    return {
      pageY: false,
      testShow: false,
      fMenu: [
        {
          flag: false,
          index: 0
        },
        {
          flag: false,
          index: 1
        },
        {
          flag: false,
          index: 2
        },
        {
          flag: false,
          index: 3
        },
        {
          flag: false,
          index: 4
        },
        {
          flag: false,
          index: 5
        },
        {
          flag: false,
          index: 6
        },
        {
          flag: false,
          index: 7
        }
      ],
      routerName: [
        "homePage",
        "brandStrength",
        "courseSystem",
        "servicePros",
        "successfulCase",
        "partnerRecruit",
        "AboutImagine"
      ],
      navTransitionHeight: {
        allFirstMenuBoxHeight: "106.4vw",
        brandStrengthHeight: 0,
        courseSystemHeight: 0,
        serviceProsHeight: 0,
        AboutImagineHeight: 0
      },

      firstRouterColor: [true, false, false, false, false, false, false, false],
      slectColor: "",
      randonNum: ""
    };
  },
  methods: {
    changeNavShowHeight(number) {
      return `${number * 15.2 +
        parseFloat(navTransitionHeight.allFirstMenuBoxHeight)}vw`;
    },
    xuanzhuanIcon: function(index) {
      let length = this.fMenu.length;
      if (!index) {
        this.fMenu[0].flag = !this.fMenu[0].flag;
        for (let i = 1; i < length; i++) {
          this.fMenu[i].flag = false;
        }
        return;
      }
      this.fMenu[index].flag = !this.fMenu[index].flag;
    },
    clickRouter: function() {
      this.slectColor = "clickColor";
    },
    routerTo: function() {
      this.randonNum = Math.random();
    },
    routerToFirst: function() {
      this.$router.push({
        name: "homePage"
      });
    },
    //课程体系-- 线上人工智能页面 滚动到特定位置后 导航消失
    pageYShowNav() {
      const clientWidth = document.body.clientWidth;
      Bus.$on("pageY", val => {
        if (clientWidth > 1680) {
          this.pageY = val[0] >= val[1];
        } else if (clientWidth <= 1680 && clientWidth > 1440) {
          this.pageY = val[0] >= val[1];
        } else if (clientWidth <= 1440 && clientWidth > 1280) {
          this.pageY = val[0] >= val[1];
        } else {
          this.pageY = val[0] >= val[1];
        }
      });
    },
    showNav() {
      Bus.$on("showNav", val => {
        this.pageY = val >= 510;
      });
    },
    showNavMb() {
      Bus.$on("showNavMb", val => {
        this.testShow = val >= 270;
      });
    },
    conceptShowNav() {
      Bus.$on("conceptShowNav", val => {
        this.pageY = val >= 720;
      });
    },
    landPCdisapperarNav() {
      Bus.$on("landPCdisapperar", bool => {
        this.pageY = !bool;
      });
    },
    landMbdisapperarNav() {
      Bus.$on("landPCdisapperar", bool => {
        this.testShow = !bool;
      });
    }
  },
  watch: {
    $route() {
      this.fMenu[0].flag = false;
    },
    randonNum(val, oldVal) {
      //普通的watch监听
      this.fMenu[0].flag = false;
    }
  },
  mounted() {
    this.pageYShowNav();
    this.showNav();
    this.showNavMb();
    this.conceptShowNav();
    this.landPCdisapperarNav();
    this.landMbdisapperarNav();
  },
  updated() {
    for (let i = 0; i < this.firstRouterColor.length; i++) {
      this.firstRouterColor[i] = false;
    }
    for (let i = 0; i < this.routerName.length; i++) {
      if (this.$route.name === this.routerName[i]) {
        this.firstRouterColor[i] = true;
        return;
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.appXiaZai:hover,
.appXiaZai:link,
.appXiaZai:visited {
  color: #666666;
  font-family: SHS-M;
}

@media screen and (max-width: 992px) {
  .pc {
    display: none !important;
  }
   .telPhone{
    color: #E1251B;
    height: vt(52);
    line-height: vt(52);
    margin-left: vt(-32);
  }
  a:link,
  a:visited {
    color: #fff;
    text-decoration: none;
  }
  a:hover {
    color: #fff;
    text-decoration: none;
  }
  .active {
    color: #fff !important;
  }
  .boxBG {
    background: rgba(4, 48, 107, 1);
    height: 122vw;
    overflow: auto;
  }
  .secondMenu {
    padding-right: 0vw;
    font-size: 2vw /* 16/75 */;
    color: #fff;
  }
  .secondMenu > div {
    margin-top: 1.8vw;
    margin-bottom: 0.1.8vw;
  }
  .flexBox {
    display: flex;
    justify-content: flex-end;
  }
  .navLogo {
    width: 43.6vw;
    height: 6vw;
  }
  .nav {
    height: 12vw;
    width: 100%;
    display: flex;
    padding-left: 2.1vw;
    box-sizing: border-box;
  }
  .navlogoBox {
    padding-top: 3vw;
    padding-bottom: 3vw;
    line-height: 12vw;
    margin-left: 4.1vw;
    width: 34vw;
    height: 12vw;
    margin-right: 11.06vw;
  }
  .navIcon {
    width: 7.2vw;
    height: 7.2vw;
  }
  .navIconBox {
    height: 12vw;
    padding-top: 2.6vw;
    margin-right: 2.667vw;
  }
  .navIconLast {
    width: 5.7vw;
    height: 0.4.3vw;
  }
  .lastIconBox {
    padding-top: 3.5vw;
    margin-left: 6.533vw;
  }
  .xialaMenu {
    text-align: right;
    font-family: SHS-R;
    height: 0;
    transition: all .3s;
    &.fade{
      height: vt(409);
  }
  }
  .xialaMenu > span {
    display: inline-block;
  }
  .iconimgXiala {
    height: 6vw;
    line-height: 6vw;
    color: #fff;
    font-family: SHS-M;
  }
  .iconimgXiala > img {
    //  display: none;
    /* 暂时隐藏三级菜单 箭头暂时隐藏掉 */
    width: 6vw;
    height: 6vw;
  }
  .xuanzhuan {
    transform: rotate(-90deg);
    display: inline-block;
  }
  /* new 导航 */
  .navTop {
    height: vt(52); //  background: red;
    padding-left: vt(16);
    box-sizing: border-box;
    display: flex; //  align-items: center;
    justify-content: space-between;
    box-shadow: 0px 3px 40px 0px rgba(56, 56, 56, 0.08);
    .navLogo {
      display: inline-block;
      width: vt(153);
      height: vt(52);
      background-size: 100% 100%;
      background-image: url(../assets/image/homePage/index/PhoneImage/phoneLogo.png);
    }
    .menuRightBox {
      width: vt(52);
      height: vt(52);
      background: rgba(4, 48, 107, 1); //  border: .1px solid rgba(0,0,0,0.04);
      box-sizing: border-box;
      text-align: center;
      line-height: vt(52);
      .menuClickBox {
        display: inline-block;
        vertical-align: middle;
        width: vt(40);
        height: vt(40);
        background-size: 100% 100%;
        background-image: url(../assets/image/homePage/index/PhoneImage/menuClick.png);
      }
    }
  }
  .menuCloseBox {
    background-image: url(../assets/image/homePage/index/PhoneImage/close_icon@2x.png) !important;
  }
  .ArrowBox {
    text-align: center;
    height: vt(57);
    width: vt(57);
    line-height: vt(57);
  } //  向下箭头
  .arrow {
    display: inline-block;
    background-size: 100% 100%;
    background-image: url(../assets/image/homePage/index/PhoneImage/arrow_down@2x.png);
    width: 10vw;
    height: 10vw;
    vertical-align: middle;
  } //  向上箭头
  .upArrow {
    background-image: url(../assets/image/homePage/index/PhoneImage/arrow_up@2x.png);
  }
  .lyrouter ::after {
    content: "";
    display: block;
    position: absolute;
    width: 89%;
    height: vt(1);
    background: #e1e1e1;
    opacity: 0.06;
    bottom: 0;
    left: 5%;
  }
  .firstMenuBox {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: vt(57);
    box-sizing: border-box;
    font-weight: 600;
    font-size: vt(18);
    color: rgba(255, 255, 255, 1);
    font-family: SHS-R;
    position: relative;
    .lyrouter {
      width: vt(150);
      height: vt(57);
      line-height: vt(57);
      opacity: 0;
      //animation-delay:1s;
      .routerBtn {
        text-align: left;
        display: inline-block;
        padding-left: vt(16);
        box-sizing: border-box;
        width: 100%;
        height: 100%;
      }
      &.fade{
        opacity: 1;
      }
    }
    .lyrouter1 {
      transition:all .3s linear;
    }
    .lyrouter2 {
      transition:all .6s linear;
    }
    .lyrouter3 {
      transition:all .9s linear;
    }
    .lyrouter4 {
      transition:all 1.2s linear;
    }
    .lyrouter5 {
      transition:all 1.5s linear;
    }
    .lyrouter6 {
      transition:all 1.8s linear;
    }
    .lyrouter7 {
      transition:all 2.1s linear;
    }
  }
  .secondMenuBox {
    position: relative;
    height: vt(57);
    box-sizing: border-box;
    font-weight: 400;
    font-size: vt(16);
    background: rgba(7, 43, 92, 1);
    .routerSecBtn {
      display: block;
      text-align: left;
      padding-left: vt(16);
      box-sizing: border-box;
      width: 100%;
      height: 100%;
      line-height: vt(57);
      opacity: .8;
    }
  }
  .secondMenuBox ::after {
    content: "";
    display: block;
    position: absolute;
    width: 89%;
    height: vt(1);
    background: #e1e1e1;
    opacity: 0.1;
    bottom: 0;
    left: 5%;
  }
  .menuSecondBg {
    background: rgba(7, 43, 92, 1);
  }
  .fontBold {
    font-weight: bold;
  }
  .phoneNavBox {
    width: 100%; //  position: absolute;
    top: 0;
    left: 0;
    z-index: 100000000;
    background: #fff;
    box-shadow: 0px 3px 40px 0px rgba(56, 56, 56, 0.08);
    position: fixed;
  }
}

@media screen and (min-width: 993px) {
  .pc {
    position: fixed !important;
    z-index: 100000;
    background: #fff;
    width: 100%;
    top: 0;
    right: 0;
    box-shadow:0px 3px 40px 0px rgba(56,56,56,0.08);
  }
  .phone {
    display: none !important;
  }
  a:link,
  a:visited {
    color: #666;
    text-decoration: none;
  }
  a:hover {
    color: #fff;
  }
  .imgMouseEnter:hover {
    cursor: pointer;
  }
  .active {
    color: #e1251b !important;
    position: relative;
  }
  .active:after {
    display: block;
    content: "";
    height: 0;
    width: 100%;
    right: 0;
    bottom: -0.4vw;
    border-bottom: 2px #e1251b solid;
    position: absolute;
  }
  * {
    text-decoration: none;
    /*float: left;*/
    list-style: none;
    padding: 0;
    margin: 0;
  }
  .top-nav {
    /* height: 75px; */
    height: 2.86458vw;
    line-height: 2.86458vw;
    background: rgb(247, 248, 248);
    padding-top: 0.70314vw;
    padding-right: 18.75vw;
    box-sizing: border-box;
    width: 100%;
  }
  .top-nav span:nth-child(1) {
    /* display: inline-block; */
    /* height:35px ; */
    /* width: 122px; */
    width: 5.208vw;
    height: 1.4583vw;
    float: right;
    /* line-height: 35px; */
    line-height: 1.4583vw;
    text-align: center;
    color: #666666;
    background: #fff;
    border: 1px solid #666666;
    /* border-radius: 17px; */
    border-radius: 0.729vw;
    margin-left: 22px;
    font-family: SHS-M;
    font-size: 0.83vw;
    /* box-sizing: border-box; */
  }
  .top-nav span:nth-child(2) {
    /* display: inline-block; */
    /* height:34px ; */
    width: 5.208vw;
    height: 1.4583vw;
    float: right;
    background: #fff;
    /* width: 118px; */
    line-height: 1.4583vw;
    /* line-height: 34px; */
    border: 1px solid #666666;
    /* border-radius: 17px; */
    border-radius: 0.729vw;
    text-align: center;
    font-size: 0.83vw;
    color: rgb(200, 201, 201);
    font-family: SHS-M;
    /* box-sizing: border-box; */
  }
  .appXiaZai {
    width: 100%;
    height: 100%;
    line-height: 1.4583vw;
  }
  .theonemenu {
    height: 7.2vw;
    margin: 0 auto;
    position: relative;
  }
  .theonemenu > li > img {
    width: vp(912);
    height: vp(56);
    transform-origin: left bottom;
    transform: scale(0.7);
    // width: 13.75vw;
    // height: 3.02vw;
  }
  .theonemenu > li {
    text-decoration: none;
    list-style: none;
    margin-right: 2.1875vw;
  }
  .theonemenu > .firstmenu {
    flex-shrink: 0;
    position: relative;
    margin-top: vp(30);
    :first-child {
      margin-left: 0;
    }
  }
  .firstmenu > a {
    font-size: 1vw;
    font-family: SHS-M; // z-index: 2 !important;
    color: #333;
  }
  .theonemenu {
    display: flex;
    justify-content: center;
    align-items: center;
    /*line-height: 60px;*/
  }
  .firstmenu:hover > a {
    color: #e1251b;
  }
  .theonemenu > li:hover::after {
    display: block;
  }
  .theonemenu > li:hover .twomenu {
    display: block;
  }
  .firstmenu:after {
    display: none;
    content: "";
    height: 0;
    width: 100%;
    right: 0;
    bottom: -0.15vw;
    bottom: -0.35vw\9;
    bottom: -0.35vw\0;
    border-bottom: 2px #e1251b solid;
    position: absolute;
  }
  .firstmenu::before {
    position: absolute;
    content: "";
    bottom: -0.58vw;
    height: 0.8vw;
    bottom: -1vw\9;
    height: 0.8vw\9;
    bottom: -1vw\0;
    height: 0.8vw\0;
    width: 100%;
    background: #e1251b;
    display: inline-block;
    opacity: 0;
  }
  .twomenu {
    position: absolute;
    font-size: 0.8vw;
    font-family: SHS-R;
    color: #666;
    width: 48vw;
    top: 2.02vw;
    display: none;
  }
  .lastmenu {
    right: 0;
  }
  .twomenu .ts {
    position: relative;
    float: left;
    /* width: 4.8vw; */
    padding-left: 0.8vw;
    padding-right: 0.8vw;
    height: 1.5vw;
    line-height: 1.5vw;
    border: #666 solid 1px;
    border-right: none;
    border-left: none;
    box-sizing: border-box;
    text-align: center;
    color: #666 !important;
  }
  .lastmenu .ts {
    float: right;
  }
  .twomenu .ts:hover {
    box-sizing: border-box;
    background: rgb(6, 47, 110);
    padding-top: 1px;
  }
  .twomenu .ts::after {
    position: absolute;
    content: "";
    height: 0.6vw;
    border-left: 1px solid black;
    right: 0;
    top: 0.4vw;
  }
  .twomenu .ts:nth-last-child(1)::after {
    border-right: 0px;
  }
  .twomenu .rBorder {
    border-right: 1px solid #666;
  }
  .twomenu .lBorder {
    border-left: 1px solid #666;
  }
  .twomenu .rBorder:after {
    height: 0;
  }
  .third-menu-hover-pc:hover .dynamicTime:before {
    border-bottom: 0.41667vw solid rgb(6, 47, 110);
  }
  /* 三角形箭头 */
  .dynamicTime:before {
    box-sizing: content-box;
    width: 0px;
    height: 0px;
    position: absolute;
    top: -0.833vw;
    right: 2.135vw;
    padding: 0;
    border-bottom: 0.41667vw solid #fff;
    border-top: 0.41667vw solid transparent;
    border-left: 0.41667vw solid transparent;
    border-right: 0.41667vw solid transparent;
    display: block;
    content: "";
    z-index: 12;
  }
  .dynamicTime:after {
    box-sizing: content-box;
    width: 0px;
    height: 0px;
    position: absolute;
    top: -0.9375vw;
    right: 2.083vw;
    padding: 0;
    border-bottom: 0.46875vw solid #666;
    border-top: 0.46875vw solid transparent;
    border-left: 0.46875vw solid transparent;
    border-right: 0.46875vw solid transparent;
    display: block;
    content: "";
    z-index: 10;
  }
  .dynamicTime {
    height: 100%;
    width: 100%;
    position: absolute;
    top: 0;
    right: 0;
  }
  .phone-number{
      position: absolute;
      top: vp(20);
      right: 3.5vw;
      // margin-right: -4vw!important;
      img{
        display: inline-block;
        vertical-align: middle;
        width: vp(22) !important;
        height: vp(22) !important;
        margin-right: vp(12);
      }
      p{
        font-size: vp(23);
        color: #E1251B;
        display: inline-block;
        vertical-align: middle;
      }
    }
}

@media screen and(max-width: 1441px) and(min-width: 992px) {
  .firstmenu::before {
    position: absolute;
    content: ""; //  bottom: 0;
    //  height: 1vw;
    width: 100%;
    background: #e1251b;
    opacity: 0;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/HomePageHeaderNav.vue